

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLEMPLOYEES= createAsyncThunk(
  "getAllEmployees/getAllEmployees",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllEmployeesSlice = createSlice({
  name: "getAllEmployeesSlice",
  initialState: {
    getAllEmployees: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllEmployees: (state) => {
        state.getAllEmployees.loading = false
        state.getAllEmployees.error = false
        state.getAllEmployees.data = []
        state.getAllEmployees.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLEMPLOYEES.fulfilled, (state, action) => {
      state.getAllEmployees = {
        ...state.getAllEmployees,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLEMPLOYEES.pending, (state, action) => {
      state.getAllEmployees = {
        ...state.getAllEmployees,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLEMPLOYEES.rejected, (state, action) => {
      state.getAllEmployees = {
        ...state.getAllEmployees,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllEmployeesAction = {
    GETALLEMPLOYEES,
};

export { getAllEmployeesAction };
export default getAllEmployeesSlice.reducer;
export const {setInitialStateOfgetAllEmployees} = getAllEmployeesSlice.actions
